import React, { useState, useContext} from 'react'
import Icon from '@material-ui/core/Icon'
import { ThemeContext } from 'styled-components'
import { AuthContext } from '../../../../../auth-context'
import CameraIcon from '@material-ui/icons/CameraAlt'
import moment from 'moment'
import '../../../../../css/inspect.sass'
import iconCheck from '../../../../../images/iconCheck.png'
import iconOver from '../../../../../images/iconOver.png'
import iconDailyWeight from '../../../../../images/scale.svg'
import iconMeasurements from '../../../../../images/ruler.svg'
import iconNotes from '../../../../../images/notes.svg'
import iconPaused from '../../../../../images/new-vacation-mode/icon-small-pause.svg'
import iconPractice from "../../../../../images/new-vacation-mode/icon-small-practice.svg";
import { DarkTooltip } from './tooltip';

import { PhotoModal } from './photo-modal'
import { DailyWeightModal } from './daily-weight-modal'
import { MeasurementModal } from './measurement-modal';
import { NotesModal } from './notes-modal';
import { CarryOverModal } from './carry-over-modal'
import ComplianceModal from './compliance-details'
import { getPortalAccountWeighInPhotos } from '../../../../../api'
import { SurveyModal } from './survey-modal'
import styled from 'styled-components'

const VacationText = styled.span`
  background: #06010d;
  border-radius: 30px;
  display: block;
  padding: 0px 4px;
  font-size: 0.7rem;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  color: ${props => props.color || "#32F6DB"};
`;

const TimelineRow = (props) => {
  if(!props.record) {
    return null
  }

  const isPaused = props.record.vacation_mode_info && !props.record.vacation_mode_info?.practice_mode
  const isPractice = props.record.vacation_mode_info && props.record.vacation_mode_info?.practice_mode

  const getRowColor = (record) => {
    const {check_in_type, complaint, vacation_mode_info} = record

    let backgroundColor

    if(check_in_type === 1) {
      backgroundColor = '#fff0f0'
    } else if(check_in_type === 2) {
      backgroundColor = '#f0fff0'
    } else {
      backgroundColor = 'none'
    }
    return { background: backgroundColor }
  }

  const formatCameraColumn = (record) => {
    return record.photo_option === 3 && (
      <DarkTooltip title={<p>Check-in has progress photos</p>}>
        <CameraIcon style={{cursor: 'pointer'}} onClick={() => props.handleCameraClick(record)} />
      </DarkTooltip>
    )
  }

  const formatWeightColumn = (record) => {
    let result
    const date = moment.utc(record.report_date).format('MMM Do')

    if (record.estimated_weight === null) {
      result = (
        <>
          {(record?.daily_weights?.length !== 0) ?
            <DarkTooltip
              title={<p>Check-in has daily weights</p>}
            >
              <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                <span onClick={() => props.handleDailyWeight({date: date, daily_weights: record.daily_weights})} style={{cursor: 'pointer'}}><img src={iconDailyWeight} alt="icon" style={{height: '14px', width: '14px', marginTop: '0px', marginLeft: '2px'}} /></span>
                <p style={{fontWeight: 400}}>{Number(record.weight * 2.204622).toFixed(1)}</p>
              </div>
            </DarkTooltip>
            :
              <p style={{fontWeight: 400}}>{Number(record.weight * 2.204622).toFixed(1)}</p>
          }
        </>
      )
    } else {
      result = (
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
          {(record?.daily_weights?.length !== 0) &&
            <DarkTooltip
              title={<p>Check-in has daily weights</p>}
            >
              <div style={{display: 'flex', alignItems: 'center'}}>
                <span onClick={() => props.handleDailyWeight({date: date, daily_weights: record.daily_weights})} style={{cursor: 'pointer'}}><img src={iconDailyWeight} alt="icon" style={{height: '14px', width: '14px', marginTop: '0px', marginLeft: '2px'}} /></span>
              </div>
            </DarkTooltip>
          }
          <DarkTooltip
            title={<p>{'Estimated weight (actual weight: ' + Number(record.weight * 2.204622).toFixed(1) + ' lbs)'}</p>}
          >
            <p style={{color: 'red'}}>{Number(record.estimated_weight * 2.204622).toFixed(1)}</p>
          </DarkTooltip>
        </div>
      )
    }
    return result
  }

  const formatBodyfatColumn = (record) => {
    const date = moment.utc(record.report_date).format('MMM Do')

    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        {(record?.measurements) ?
          <DarkTooltip
            title={<p>Check-in has measurements</p>}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span onClick={() => props.handleMeasurement({date: date, data: record.measurements})} style={{cursor: 'pointer'}}><img src={iconMeasurements} alt="icon" style={{height: '14px', width: '14px', marginTop: '0px', marginLeft: '2px'}} /></span>
              <p style={{fontWeight: 400}}>{record.body_fat + '%'}</p>
            </div>
          </DarkTooltip>
          :
          <p style={{fontWeight: 400}}>{record.body_fat + '%'}</p>
        }
      </div>
    )
  }

  const formatRangeColumn = (record) => {
    if(record.check_in_type === 12 && isPaused) {
      return (
        <DarkTooltip
          title={<p>Goal was paused</p>}
        >
          <img src={iconPaused} onClick={() => {props.handleShowCompliance(record.report_date.slice(0, 10))}} alt="icon" style={{height: '24px', width: '24px', marginTop: '0px', marginLeft: '2px', cursor: 'pointer'}} />
        </DarkTooltip>
      )
    } else if(record.check_in_type === 12 && isPractice) {
      return (
        <DarkTooltip
          title={<p>Practice mode</p>}
        >
          <img src={iconPractice} onClick={() => {props.handleShowCompliance(record.report_date.slice(0, 10))}} alt="icon" style={{height: '24px', width: '24px', marginTop: '0px', marginLeft: '2px', cursor: 'pointer'}} />
        </DarkTooltip>
      )
    } else {
      if (record.check_in_type <= 2) {
        return (
          <DarkTooltip
            title={<p>{record.compliant ? 'In range of macros' : 'Out of range of macros'}</p>}
          >
            <img className='timeline-table-compliant' src={record.compliant ? iconCheck : iconOver} alt={record.compliant ? 'in range' : 'out of range'} onClick={() => {props.handleShowCompliance(record.report_date.slice(0, 10))}} />
          </DarkTooltip>
        )
      } else {
        return props.checkInType
      }
    }
  }

  const showCarryIcon = (record) => {
    if(record.keep) {
      return (
        <>
          <DarkTooltip
            title={<p>User kept old macros</p>}
          >
            <Icon style={{ color: 'purple', fontSize: '16px', cursor: 'pointer'}} onClick={() => props.handleCarryOver(record)}>update</Icon>
          </DarkTooltip>
        </>
      )
    } else if(record.custom_calories !== null) {
      return (
        <>
          <DarkTooltip
            title={<p>Custom calories set</p>}
          >
            <Icon style={{ color: 'purple', fontSize: '16px'}}>edit</Icon>
          </DarkTooltip>
        </>
      )
    }
  }

  const createActions = (record) => {
    const date = moment.utc(record.report_date).format('MMM Do')
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '4px'}}>
        {record?.coach_edited && 
          <DarkTooltip
            title={<p>Check-in was edited by a coach</p>}
          >
            <Icon style={{color: '#800080', paddingTop: '1px', margin: '0px 6px'}}>sports</Icon>
          </DarkTooltip>
        }
        {record?.notes?.length > 0 && 
          <DarkTooltip
            title={<p>Check-in has notes attached</p>}
          >
            <span onClick={() => props.handleNotes({ date: date, data: record.notes })} style={{cursor: 'pointer'}}>
              <img src={iconNotes} alt="icon" style={{height: '18px', width: '18px', marginTop: '3px', margin: '0px 6px'}} />
            </span>
          </DarkTooltip>
        }
      </div>  
    )
  }

  const getSurveyData = (record) => {
    const timelineEntry = props.timeline.find(t => record.weight_id === t.id)
    if(timelineEntry) {
      return timelineEntry.survey
    } else {
      return null
    }
  }

  return (
    <div
      className="custom-table-row"
      style={getRowColor(props.record)}
      id="timeline-table-row"
    >
      <div className='date spacer-right'><p>{props.date}</p></div>
      <>
        <div className='camera'>{props.user.portal_user_info?.trainer_permission_photos === 1 && formatCameraColumn(props.record)}</div>
        <div className='survey'>
          {props?.record?.survey_response_id && 
            <Icon style={{ color: '#54d054', cursor: 'pointer'}} onClick={() => props.handleShowSurvey(getSurveyData(props.record))}>assignment</Icon>
          }
        </div>
        <div className='weight spacer-left'>{formatWeightColumn(props.record)}</div>
        <div className='bf'>{formatBodyfatColumn(props.record)}</div>
        {(props.user.gender === 'FEMALE') &&
          <div className='near-period'>
            {(props.record.menstrual_retaining === 1 || props.record.estimated_weight !== null) ? 
              <DarkTooltip
                title={<p>Period is affecting weight</p>}
              >
                <p>Yes</p>
              </DarkTooltip>
            : 
              <DarkTooltip
                title={<p>Period is not affecting weight</p>}
              >
                <p>No</p>
              </DarkTooltip>
            }
          </div>
        }
        <div className='measurement spacer-right'>
          {formatRangeColumn(props.record)}
        </div>
      </>
      <div className='goal spacer-left spacer-right'>
        {isPaused && <VacationText color="#32F6DB">Goal paused</VacationText>}
        {isPractice && <VacationText color="#CFE92A">Practice mode</VacationText>}
        <p>{props.goal}</p>
        <p>{props.goalLevel}</p>
      </div>

      <div className='protein spacer-left'><p>{Math.round(props.record.protein)}</p></div>
      <div className='carbs'><p>{Math.round(props.record.carbs)}</p></div>
      <div className='fat'><p>{Math.round(props.record.fat)}</p></div>
      <div className='calories spacer-right'>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          {showCarryIcon(props.record)}
          <p>{((Math.round(props.record.protein) + Math.round(props.record.carbs)) * 4 + Math.round(props.record.fat) * 9)}</p>
        </div>
      </div>
      <div className='actions spacer-left'>{createActions(props.record)}</div>
    </div>
  )
};






















const RecentCheckIns = (props) => {
  const account = props.account
  const ascendingOrder = props.ascendingOrder
  const { user } = useContext(AuthContext)
  const theme = useContext(ThemeContext)
  const [photoData, setPhotoData] = useState({show: false, record: null, loading: false, photos: null})
  const [showDailyWeightModal, setShowDailyWeightModal] = useState(false)
  const [dailyWeightData, setDailyWeightData] = useState('')
  const [showMeasurementModal, setShowMeasurementModal] = useState(false)
  const [measurementData, setMeasurementData] = useState('')
  const [showNotesModal, setShowNotesModal] = useState(false)
  const [notesData, setNotesData] = useState('')
  const [showCarryOverModal, setShowCarryOverModal] = useState(false)
  const [carryOverData, setCarryOverData] = useState('')
  const [showComplianceModal, setShowComplianceModal] = useState(false)
  const [complianceDate, setComplianceDate] = useState('')
  const [showSurveyModal, setShowSurveyModal] = useState(false)
  const [surveyData, setSurveyData] = useState('')

  const handleCameraClick = (checkinData) => {
    const timelineEntry = account.timeline.find(t => checkinData.weight_id === t.id)

    if (!photoData.loading) {
      if (photoData.record !== null && photoData.id === timelineEntry.id) {
        setPhotoData({show: true, record: timelineEntry, loading: false, photos: photoData.photos})
      } else {
        setPhotoData({show: true, record: timelineEntry, loading: true, photos: null})
        getPortalAccountWeighInPhotos(user.id, props.accountId, timelineEntry.id).then((res) => {
          setPhotoData({show: true, record: timelineEntry, loading: false, photos: res.data.photos})
        })
      }
    }
  }

  const handlePhotoModalClose = () => {
    if (!photoData.loading) {
      setPhotoData({show: false, record: photoData.record, loading: false, photos: photoData.photos})
    }
  }

  const handleShowCompliance = (date) => {
    setShowComplianceModal(true);
    setComplianceDate(date)
  }

  const formatCheckInType = (record) => {
    let checkInType
    switch (record.check_in_type) {
      case 1:
        checkInType = 'No'
        break

      case 2:
        checkInType = 'Yes'
        break

      case 3:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
        checkInType = 'Forced'
        break

      case 4:
        checkInType = 'Start'
        break

      case 10:
      case 11:
        checkInType = 'Reset'
        break

      default:
        checkInType = ''
    }
    return checkInType
  }

  const getGoalLevel = (record) => {
    const LBS_PER_KG = 2.204622
    const goal = record.goal
    const targetWeight = record.target_weight
    const goal_weight_delta = record.goal_weight_delta
    const goal_min_weekly_calorie_increase = record.goal_min_weekly_calorie_increase

    if(!goal) // NOTE: Required when getUserFetch is not completed
      return

    if(goal === 'MAINTENANCE') {
      return ((targetWeight - goal_weight_delta) * LBS_PER_KG).toFixed(1) + ' - ' + ((targetWeight + goal_weight_delta) * LBS_PER_KG).toFixed(1) + ' lbs'
    } else if(goal === 'REVERSE DIETING') {
      return goal_min_weekly_calorie_increase + ' - ' + (goal_min_weekly_calorie_increase + 15) + ' kCal/wk'
    } else {
      return (goal_weight_delta * LBS_PER_KG).toFixed(2) + ' lbs/wk'
    }
  }

  if(!account) {
    return null
  }

  let recentCheckins = [...account.user.weighins]

  // Last 6 check-ins
  recentCheckins = recentCheckins.slice(0, 6)

  let relatedWeighInDateString = null
  if(complianceDate && account.user.starting_point && complianceDate >= account.user.starting_point.slice(0, 10)) {
    for(let key in props.macroData.weighInDetails) {
      if(key < complianceDate && (relatedWeighInDateString === null || key > relatedWeighInDateString)) {
        relatedWeighInDateString = key
      }
    }
  }

  return (
    <>
      <div className='custom-table recent' id='custom-table-override'>
        <div className='custom-table-header-scroll' id='timeline-table-header'>
          <div className='date spacer-right'>
            <DarkTooltip
              placement="top"
              title={<p>This displays the date of this event.</p>}
            >
              <p style={{fontWeight: 'bold'}}>Date</p>
            </DarkTooltip>
          </div>
          <div className='camera'></div>
          <div className='survey'></div>
          <div className='weight spacer-left'>
            <DarkTooltip
              placement="top"
              title={
                <>
                  <p>This displays weight at each date.</p>
                  <p style={{fontStyle: 'italic'}}><span><img src={iconDailyWeight} alt="icon" style={{height: '14px', width: '14px', marginTop: '4px', marginRight: '8px'}} /></span> * Tap to view daily weights</p>
                </>
              }
            >
              <p style={{fontWeight: 'bold'}}>Weight<br/> (lbs)</p>
            </DarkTooltip>
          </div>
          <div className='bf'>
            <DarkTooltip
              placement="top"
              title={
                <>
                  <p>This displays body fat percentage at each date.</p>
                  <p style={{fontStyle: 'italic'}}><span><img src={iconMeasurements} alt="icon" style={{height: '14px', width: '14px', marginTop: '4px', marginRight: '8px'}} /></span> * Tap to view measurements</p>
                </>
              }

            >
              <p style={{fontWeight: 'bold'}}>BF%</p>
            </DarkTooltip>
          </div>
          {account.user.gender === 'FEMALE' &&
            <div className='near-period spacer-right'>
              <DarkTooltip
                placement="top"
                title={<p>This shows whether a user’s menstrual cycle was affecting their weight.</p>}
              >
                <p style={{fontWeight: 'bold'}}>Near Period</p>
              </DarkTooltip>
            </div>
          }
          <div className='measurement spacer-right'>
            <DarkTooltip
              placement="top"
              title={
                <>
                  <p>This shows where the client is at in their current check-in period:</p>
                  <div style={{height: '8px'}}></div>
                  <li><span><img className='timeline-table-compliant' src={iconCheck} alt="icon" style={{height: '16px', width: '16px'}} /></span> In range of macros</li>
                  <li><span><img className='timeline-table-compliant' src={iconOver} alt="icon" style={{height: '16px', width: '16px'}} /></span> Out of range of macros</li>
                  <li>Forced check-in (User changed a setting that required a new starting weight)</li>
                  <div style={{height: '16px'}}></div>
                  <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <img className='timeline-table-compliant' src={iconCheck} alt="icon" style={{height: '16px', width: '16px', marginRight: '4px'}} />
                    <img className='timeline-table-compliant' src={iconOver} alt="icon" style={{height: '16px', width: '16px', marginRight: '4px'}} />
                    <p style={{fontStyle: 'italic'}}>* Tap these icons to view the average tracked macros for this check-in.</p>
                  </div>
                </>
              }
            >
              <p style={{fontWeight: 'bold'}}>In <br/> range</p>
            </DarkTooltip>
          </div>

          <div className='goal spacer-left spacer-right'>
            <DarkTooltip
              placement="top"
              title={<p>This displays the goal for each date.</p>}
            >
              <p style={{fontWeight: 'bold'}}>Goal</p>
            </DarkTooltip>
          </div>
          <div className='protein spacer-left'>
            <DarkTooltip
              placement="top"
              title={<p>This displays the protein target for each date.</p>}
            >
              <p style={{fontWeight: 'bold'}}>Protein</p>
            </DarkTooltip>
          </div>
          <div className='carbs'>
            <DarkTooltip
              placement="top"
              title={<p>This displays the carbs target for each date.</p>}
            >
              <p style={{fontWeight: 'bold'}}>Carbs</p>
            </DarkTooltip>
          </div>
          <div className='fat'>
            <DarkTooltip
              placement="top"
              title={<p>This displays the fat target for each date.</p>}
            >
              <p style={{fontWeight: 'bold'}}>Fat</p>
            </DarkTooltip>
          </div>
          <div className='calories spacer-right'>
            <DarkTooltip
              placement="top"
              title={<p>This displays the calorie target for each date.</p>}
            >
              <p style={{fontWeight: 'bold'}}>kCal</p>
            </DarkTooltip>
          </div>

          <div className='actions spacer-left'>
            <DarkTooltip
              placement="top"
              title={
                <>
                  <p>This shows the available actions for this date:</p>
                  <div style={{height: '8px'}}></div>
                  <p><Icon style={{color: '#800080', paddingTop: '1px', marginRight: '8px', fontSize: '1.125rem'}}>sports</Icon> Check-in was edited by a coach</p>
                  <div style={{height: '16px'}}></div>
                  <p style={{fontStyle: 'italic'}}><span><img src={iconNotes} alt="icon" style={{ height: '14px', width: '14px', marginTop: '4px', marginRight: '8px'}} /></span> * Tap to view notes</p>
                </>
              }
            >
              <p style={{fontWeight: 'bold'}}>Actions</p>
            </DarkTooltip>
          </div>
        </div>
        {recentCheckins.map((record, index) => {
          const date = (moment.utc(record.report_date).format('MMM D, YYYY'));
          const checkInType = formatCheckInType(record)

          return (
            <TimelineRow
              key={index}
              date={date}
              goal={theme.goal[record.goal]}
              goalLevel={getGoalLevel(record)}
              record={record}
              user={account.user}
              timeline={account.timeline}
              checkInType={checkInType}
              handleCameraClick={handleCameraClick}
              handleDailyWeight={(data) => {setShowDailyWeightModal(true); setDailyWeightData(data)}}
              handleMeasurement={(data) => {setShowMeasurementModal(true); setMeasurementData(data)}}
              handleNotes={(data) => {setShowNotesModal(true); setNotesData(data)}}
              handleCarryOver={(data) => {setShowCarryOverModal(true); setCarryOverData(data)}}
              handleShowCompliance={(date) => {handleShowCompliance(date)}}
              handleShowSurvey={(data) => {setShowSurveyModal(true); setSurveyData(data);}}
            />
            )
        })}
      </div>

      <PhotoModal
        open={photoData.show}
        onClose={handlePhotoModalClose}
        record={photoData.record}
        loading={photoData.loading}
        photos={photoData.photos}
        accountId={props.accountId}
        account={account}
      />

      <DailyWeightModal
        open={showDailyWeightModal}
        onClose={() => setShowDailyWeightModal(false)}
        data={dailyWeightData}
      />

      <MeasurementModal
        open={showMeasurementModal}
        onClose={() => setShowMeasurementModal(false)}
        data={measurementData}
      />

      <NotesModal
        open={showNotesModal}
        onClose={() => setShowNotesModal(false)}
        data={notesData}
      />

      <CarryOverModal
        open={showCarryOverModal}
        onClose={() => setShowCarryOverModal(false)}
        data={carryOverData}
      />

      <ComplianceModal
        open={showComplianceModal}
        handleClose={() => setShowComplianceModal(false)}
        complianceDetailsDate={complianceDate}
        relatedWeighInDateString={relatedWeighInDateString}
        relatedWeighInDetails={props.macroData.weighInDetails[relatedWeighInDateString] || null}
        getMacroData={props.getMacroData}
        vacationMode={account.user.vacation_mode}
      />

      <SurveyModal
        open={showSurveyModal}
        onClose={() => setShowSurveyModal(false)}
        data={surveyData}
      />
    </>
  )
}

export default RecentCheckIns
